import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface DashboardStats {
  totalLeadsHoje: number;
  novosFornecedoresSemana: number;
  mrr: number;
  totalFornecedores: number;
  totalCategorias: number;
  totalTestemunhos: number;
  fornecedoresDestaque: number;
  fornecedoresAtivos: number;
  fornecedoresInativos: number;
  totalLeadsMes: number;
  rendaPrevista: number;
  assinaturasVencendo30Dias: number;
  fornecedoresFree: number;
  fornecedoresVitrine: number;
  leadsNaoLidos: number;
  removalRequests?: number;
  pendingAdhesions?: number;
}

export interface Lead {
  id: string;
  noiva: string;
  email: string;
  telefone?: string;
  fornecedorId: string;
  fornecedorNome: string;
  mensagem: string;
  criadoEm: string;
  status: string;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  constructor(private api: ApiService) {}

  getStats(): Observable<DashboardStats> {
    // Ajustado para rota real do backend
    return this.api.get<DashboardStats>('/admin/dashboard');
  }

  getLeads(page = 1, pageSize = 20, filters?: any): Observable<{ data: Lead[]; meta: any }> {
    const params = { page, pageSize, ...(filters || {}) };
    return this.api.get('/admin/leads', params) as Observable<any>;
  }

  resendLeadEmail(leadId: string): Observable<any> {
    return this.api.post(`/admin/leads/${leadId}/resend`, {});
  }
}
